/* THE DT CURRENTLY USES SEGMENT AS THE DATA TRACKING TOOL */

/* By default, we don't need to send timestamp, as it is sent by default */

export const TYPE_PAGE = 'TYPE_PAGE';
export const page = (pageName, properties) => {
  if (!pageName) {
    throw new Error('Analytics error: missing page name.');
  }

  if (!window.analytics) {
    throw new Error('Analytics error: missing analytics integration.');
  }

  return window.analytics.page(pageName, properties);
};

export const TYPE_TRACK = 'TYPE_TRACK';
export const track = (eventName, properties) => {
  if (!eventName) {
    throw new Error('Analytics error: missing event name.');
  }

  if (!window.analytics) {
    throw new Error('Analytics error: missing analytics integration.');
  }

  return window.analytics.track(eventName, properties);
};

export const TYPE_IDENTIFY = 'TYPE_IDENTIFY';
export const identify = (userId, traits) => {
  if (!userId) {
    throw new Error('Analytics error: missing user ID.');
  }

  if (!window.analytics) {
    throw new Error('Analytics error: missing analytics integration.');
  }

  return window.analytics.identify(userId, traits);
};

export const reset = () => {
  if (!window.analytics) {
    throw new Error('Analytics error: missing analytics integration.');
  }

  return window.analytics.reset();
};

export const eventEmitter = ({ type, payload }) => {
  switch (type) {
    case TYPE_PAGE:
      return page(payload.name, payload.properties);
    case TYPE_TRACK:
      return track(payload.name, payload.properties);
    case TYPE_IDENTIFY:
      return identify(payload.id, payload.properties);
    default:
      return null;
  }
};

export default {
  TYPE_PAGE,
  TYPE_TRACK,
  TYPE_IDENTIFY,
  page,
  eventEmitter,
  identify,
  track,
  reset,
};



// WEBPACK FOOTER //
// ../utils/functions/analytics.js